import { differenceInSeconds } from 'date-fns';
import { ModerationViewModel } from '@common/model/moderation/moderationViewModel';

export const isFirstModeration = (moderation: ModerationViewModel): boolean => {
  return differenceInSeconds(new Date(moderation.updatedAt), new Date(moderation.createdAt)) < 1;
};
